import React, { useState, useEffect, useContext } from 'react';
import {StyledContactForm} from "./styled";
import {
    FaUser,
    FaAt,
    FaBriefcase,
    FaMobileAlt,
    FaRegCommentAlt,
    FaFlag,
    FaGlobe
} from 'react-icons/fa';
import { getCountries } from '../../utilities'
import { AppContext } from '../../contexts'
import axios from "axios";
import { useHistory } from "react-router-dom";

const FORM_SERVICE_URL = "https://submit-form.com/Gfg4x6s68GqUNdfanqPaV"
//const FORM_SERVICE_URL = "https://submit-form.com/P4QVz7Fr" // tom's for testing


const ContactForm = (props) => {
    const [countryCode, setCountryCode] = useState('US')
    const [validation, setValidation] = useState({})
    const { variant,hideform } = props
    const history = useHistory();

    const { appData: {
        isTrial
    }, updateAppContext} = useContext(AppContext);

    useEffect(() => {
        updateAppContext('isTrial', false)
    }, [])

    const mailWallForm = variant && variant === 'mailwall' && isTrial

    const sendContactForm = (data) => {
        axios.post(FORM_SERVICE_URL, data)
            .then(function (response) {
                history.push("/contact-form-thank-you");
            })
            .catch(function (error) {
                alert('Error - sending contact form has failed');
            });
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;
        let validationClasses = {}
        let data = {}
        let formValid = true
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        for ( let i = 0; i < form.elements.length; i++ ) {
            const e = form.elements[i];

            validationClasses[e.name] = e.required && ! e.value ? "error" : "success"

            if (e.type === 'email' && e.value && ! emailRegex.test(e.value)) {
                validationClasses[e.name] = "error"
            }

            if (formValid && validationClasses[e.name] === "error") {
                formValid = false
            }

            if (e.type && e.value) {
                if (e.type === 'checkbox' && ! e.checked) {
                    continue
                }

                data[e.name] = e.type === 'checkbox' ? true : e.value
            }
        }

        if (formValid) {
            return sendContactForm(data)
        }

        return setValidation(validationClasses)
    };

    const handleTrialCheckboxChange = (e) => {
        updateAppContext('isTrial', e.target.checked)
    }

    const handleCountryOptionChange = (e) => {
        setCountryCode(e.target.value)
    }

    const countriesOptions = () => {
        let options = getCountries().map(country => {
            return (
                <option value={country.code} key={'country-' + country.code}>{country.name}</option>
            )
        })

        options.unshift(
            <option value="" key={'country-default'} disabled>Select country</option>
        )

        return options
    }
    return (
        <StyledContactForm className="ContactForm" id="ContactForm">
            {
                hideform === 'true' ?
                <h2></h2>
               :
               <h2> START 30 DAY TRIAL NOW</h2>
            }
            <form
                noValidate
                onSubmit={handleSubmit}
            >
                <div className={`ContactForm-input-container ${validation.fullName ? validation.fullName : ""}`}>
                    <div className="ContactForm-input">
                        <FaUser />
                        <input name="fullName" placeholder="Full Name" type="text" required/>
                    </div>
                    <div className="ContactForm-input-message">This field is required</div>
                </div>

                <div className={`ContactForm-input-container ${validation.company ? validation.company : ""}`}>
                    <div className="ContactForm-input">
                        <FaBriefcase />
                        <input name="company" placeholder="Company Name" type="text" required/>
                    </div>
                    <div className="ContactForm-input-message">This field is required</div>
                </div>

                <div className={`ContactForm-input-container ${validation.email ? validation.email : ""}`}>
                    <div className="ContactForm-input">
                        <FaAt />
                        <input name="email" placeholder={mailWallForm ? "Business Email Address (the domain to be protected)" : "Email"} type="email" required/>
                    </div>
                    <div className="ContactForm-input-message">This field is required</div>
                </div>

                <div className={`ContactForm-input-container ${validation.phone ? validation.phone : ""}`}>
                    <div className="ContactForm-input">
                        <FaMobileAlt />
                        <input name="phone" placeholder="Contact number (including international dialing code)" type="tel" required/>
                    </div>
                    <div className="ContactForm-input-message">This field is required</div>
                </div>

                <div className={`ContactForm-input-container ${validation.country ? validation.country : ""}`}>
                    <div className="ContactForm-input">
                        <FaFlag />
                        <select
                            name="country"
                            onChange={e => handleCountryOptionChange(e)}
                            value={countryCode || ""}
                            required
                        >
                            {countriesOptions()}
                        </select>
                    </div>
                    <div className="ContactForm-input-message">This field is required</div>
                </div>

                {
                    mailWallForm && (
                        <>
                            <div className={`ContactForm-input-container ${validation.primaryIp ? validation.primaryIp : ""}`}>
                                <div className="ContactForm-input">
                                    <FaGlobe />
                                    <input name="primaryIp" placeholder="Primary Mail server IP or A record" type="text"/>
                                </div>
                                <div className="ContactForm-input-message"></div>
                            </div>
                            <div className={`ContactForm-input-container ${validation.secondaryIp ? validation.secondaryIp : ""}`}>
                                <div className="ContactForm-input">
                                    <FaGlobe />
                                    <input name="secondaryIp" placeholder="Secondary Mail server IP or A record" type="text"/>
                                </div>
                                <div className="ContactForm-input-message"></div>
                            </div>
                            <div className={`ContactForm-input-container ${validation.relayIp ? validation.relayIp : ""}`}>
                                <div className="ContactForm-input">
                                    <FaGlobe />
                                    <input name="relayIp" placeholder="Additional relay IP addresses for outbound mail" type="text"/>
                                </div>
                                <div className="ContactForm-input-message"></div>
                            </div>
                        </>
                    )
                }

                <div className={`ContactForm-input-container ${validation.message ? validation.message : ""}`}>
                    <div className="ContactForm-input textarea">
                        <FaRegCommentAlt />
                        <textarea
                            name="message"
                            placeholder="Please, type your message here"
                            rows="3"
                            cols="1"
                            maxLength="500"
                        />
                    </div>
                    <div className="ContactForm-input-message"></div>
                </div>

                <div className="ContactForm-checkbox-container">
                    <div className="ContactForm-checkbox">
                        <input
                            name="arrangeTrial"
                            type="checkbox"
                            id="ContactForm-trial"
                            onChange={handleTrialCheckboxChange}
                        />
                        <label title="Arrange a trial" htmlFor="ContactForm-trial" className="form-check-label">Arrange a trial</label>
                    </div>

                    <div className="ContactForm-checkbox">
                        <input
                            name="getQuote"
                            type="checkbox"
                            id="ContactForm-quote"
                        />
                        <label title="Get a Quote" htmlFor="ContactForm-quote" className="form-check-label">Get a Quote</label>
                    </div>

                    <div className="ContactForm-checkbox">
                        <input
                            name="bookDemo"
                            type="checkbox"
                            id="ContactForm-demo"
                        />
                        <label title="Book a Demo" htmlFor="ContactForm-demo" className="form-check-label">Book a Demo</label>
                    </div>
                    <div className="ContactForm-checkbox">
                        <input
                            name="callMe"
                            type="checkbox"
                            id="ContactForm-call"
                            className="form-check-input"
                        />
                        <label title="Call Me" htmlFor="ContactForm-call" className="form-check-label">Call Me</label>
                    </div>
                </div>

                <button type="submit">Submit</button>
            </form>
        </StyledContactForm>
    )
}

export default ContactForm
